import {
  CREDENTIALS,
  LANGUAGE,
  RESET,
  UPDATE_AUTH,
  UPDATE_CUSTOMER_ID,
  SELECT_STORE,
} from '../types/user';

export type UserState = {
  email: string;
  name: string;
  mobile: string;
  language: string;
  authenticated: boolean;
  principalId: number;
  otp: number;
  token: string;
  selectedStore: number;
  storeName: string;
  accessType: string;
  role: string;
};

const initialState: UserState = {
  email: '',
  name: '',
  mobile: '',
  language: 'en',
  authenticated: false,
  principalId: 0,
  otp: 0,
  token: '',
  selectedStore: 0,
  storeName: '',
  accessType: '',
  role: '',
};

export default function reducer(state: UserState = initialState, action: any) {
  switch (action.type) {
    case RESET:
      return initialState;
    case CREDENTIALS:
      return { ...state, ...action.payload };
    case UPDATE_AUTH:
      return { ...state, authenticated: action.payload };
    case LANGUAGE:
      return { ...state, language: action.payload.language };
    case SELECT_STORE:
      return { ...state, ...action.payload };
    case UPDATE_CUSTOMER_ID:
      return { ...state, principalId: action.payload };
    default:
      return state;
  }
}
